const AuxContainer = (props) => {
    return props.children;
};

export default AuxContainer;